__turbopack_context__.v({
  "datepicker-button": "DatePicker-module-scss-module__n3hJDG__datepicker-button",
  "datepicker-button--selected": "DatePicker-module-scss-module__n3hJDG__datepicker-button--selected",
  "datepicker-button-last": "DatePicker-module-scss-module__n3hJDG__datepicker-button-last",
  "datepicker-button-last--selected": "DatePicker-module-scss-module__n3hJDG__datepicker-button-last--selected",
  "datepicker-last-row": "DatePicker-module-scss-module__n3hJDG__datepicker-last-row",
  "datepicker-wrapper": "DatePicker-module-scss-module__n3hJDG__datepicker-wrapper",
});
